import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import MaterialIcon from '../../../../components/MaterialIcon/MaterialIcon';
import { useDocumentKeyDown } from '../../../../helpers/Accessibility';
import ExampleGroup, { Example } from './ExampleGroup';
import styles from './PhotoExamplesModal.module.scss';

const GOOD_EXAMPLES: Example[] = [
  { captionKey: 'meterkast:photoExamplesGoodOverview', src: '/assets/good-example-1.jpeg', wide: true },
  { captionKey: 'meterkast:photoExamplesGoodDetail', detail: true, src: '/assets/good-example-2.jpeg' },
  { detail: true, src: '/assets/good-example-3.png' },
];

const BAD_EXAMPLES: Example[] = [
  { captionKey: 'meterkast:photoExamplesBadCaption', src: '/assets/bad-example-1.jpeg' },
];

interface PhotoExamplesModalProps {
  onClose: () => void;
}

const PhotoExamplesModal: FC<PhotoExamplesModalProps> = ({ onClose }) => {
  const { t } = useTranslation();

  useDocumentKeyDown({
    key: 'Escape',
    handler: onClose,
  });

  return (
    <div className={styles.overlay}>
      <button
        aria-label={t('meterkast:photoExamplesClose')}
        className={styles.backdrop}
        data-test-id="photo-examples-backdrop"
        onClick={onClose}
        type="button"
      />
      <div
        aria-labelledby="photo-examples-title"
        aria-modal="true"
        className={styles.dialog}
        role="dialog"
      >
        <header className={styles.header}>
          <button
            aria-label={t('meterkast:photoExamplesClose')}
            className={styles.close}
            data-test-id="photo-examples-close"
            onClick={onClose}
            type="button"
          >
            <MaterialIcon name="close" size={24} />
          </button>
        </header>
        <div className={styles.examples}>
          <ExampleGroup
            examples={GOOD_EXAMPLES}
            heading={t('meterkast:photoExamplesGood')}
            icon="check_circle"
            variant="good"
          />
          <ExampleGroup
            examples={BAD_EXAMPLES}
            heading={t('meterkast:photoExamplesBad')}
            icon="error"
            variant="bad"
          />
        </div>
      </div>
    </div>
  );
};

export default PhotoExamplesModal;
